import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import { AuthLayout } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If this email exists, a reset code has been sent");
      navigate("/reset-password", { state: { email } });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="text-xs uppercase tracking-[0.24em] text-cyan-400 mb-3">Reset access</div>
      <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tighter">Forgot your password?</h1>
      <p className="text-sm text-zinc-400 mt-2">Enter your email and we'll send you a reset code.</p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="email" className="text-xs uppercase tracking-widest text-zinc-500">Email</Label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
            <Input data-testid="forgot-email" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 pl-10 bg-white/5 border-white/10 focus-visible:ring-cyan-500/40 focus-visible:border-cyan-500/60" />
          </div>
        </div>
        <Button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-primary w-full h-12 rounded-full font-semibold text-base">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset code"}
        </Button>
      </form>

      <div className="mt-6 text-sm text-center text-zinc-400">
        <Link to="/login" data-testid="forgot-back-login" className="text-fuchsia-400 hover:text-fuchsia-300 font-medium">Back to sign in</Link>
      </div>
    </AuthLayout>
  );
}
